import { GetInitiativesRequest } from './getInitiatives';
import { createDeleteEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type DeleteInitiativesBulkRequest = GetInitiativesRequest & {
	initiativeIdsToExclude?: Array<number>;
};

export const deleteInitiativesBulk = createDeleteEndpoint<DeleteInitiativesBulkRequest>(
	({ initiativeIdsToExclude, ...rest }) => `/api/v3/initiatives/inverse-selection?${getQueryString(rest)}`,
	{
		requestTransform: ({ initiativeIdsToExclude }) => initiativeIdsToExclude
	}
);
